import { render, staticRenderFns } from "./TFileInput.vue?vue&type=template&id=ea7a25b4&scoped=true&"
import script from "./TFileInput.vue?vue&type=script&lang=js&"
export * from "./TFileInput.vue?vue&type=script&lang=js&"
import style0 from "./TFileInput.vue?vue&type=style&index=0&id=ea7a25b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7a25b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VFileInput,VIcon})
